import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

type FinancialYearResponse = {
	month: number;
};

const RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR = 'RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR';

export const arjSettingsFinancialYearResource: RouteResource<FinancialYearResponse> =
	createResource<FinancialYearResponse>({
		type: RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR,
		getKey: () => 'financial-year-information',
		getData: async () => fetchJson('/rest/jpo/1.0/fiscalYear'),
		maxAge: 0,
	});
